import { toast } from 'sonner';
import { useState } from 'react';
import { useUpdateClientReview } from '../../hooks/useClientReviews';
import { toUserFacingMessage } from '@overlayqa/shared';
import { SelectDropdown } from '../shared/SelectDropdown';
import { capture } from '@/lib/analytics';

/** Save only this link's preference; keep the confirmed value on a refused write. */
export function ClientReviewResponsiveSetting({ id, allowed }: { id: string; allowed: boolean }) {
  const update = useUpdateClientReview();
  const [pendingValue, setPendingValue] = useState<boolean | null>(null);
  const value = pendingValue ?? allowed;
  return (
    <SelectDropdown
      id={`client-review-responsive-${id}`}
      aria-label="Responsive views"
      value={value ? 'on' : 'off'}
      disabled={update.isPending}
      variant="ghost"
      options={[{ value: 'on', label: 'On' }, { value: 'off', label: 'Off' }]}
      onChange={next => {
        const on = next === 'on';
        if (on === value) return;
        capture('client_review_responsive_changed', { allowed: on });
        setPendingValue(on);
        update.mutate({ id, allowResponsiveViews: on }, {
          onSettled: () => setPendingValue(null),
          onError: error => toast.error(toUserFacingMessage(error, 'Could not save responsive views. Try again.')),
        });
      }}
    />
  );
}
